import React from 'react';
import { Sparkles, UserRound } from 'lucide-react';
import {
  getListingOrigin,
  isAiMadeListing,
  isHumanMadeListing,
} from '../../lib/marketplace';

export type ListingOriginType = 'wersee_ai' | 'human_made';
export { getListingOrigin, isAiMadeListing, isHumanMadeListing };

export interface ListingOriginBadgeProps {
  listing?: any;
  origin?: ListingOriginType;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

export const ListingOriginBadge = ({
  listing,
  origin: explicitOrigin,
  size = 'sm',
  className = '',
}: ListingOriginBadgeProps) => {
  const origin = explicitOrigin || (listing ? getListingOrigin(listing) : 'human_made');
  const isAi = origin === 'wersee_ai';

  const sizeClass = {
    xs: 'ws-origin-badge--xs',
    sm: 'ws-origin-badge--sm',
    md: 'ws-origin-badge--md',
    lg: 'ws-origin-badge--lg',
  }[size];

  return (
    <span
      className={`ws-origin-badge ${isAi ? 'is-ai' : 'is-human'} ${sizeClass} ${className}`.trim()}
      title={isAi ? 'Gemaakt met Wersee AI Studio' : 'Handgemaakt door een onafhankelijke menselijke maker'}
      aria-label={isAi ? 'Wersee AI listing' : 'Human made listing'}
    >
      {isAi ? (
        <>
          <Sparkles className="shrink-0" />
          <span>Wersee AI</span>
        </>
      ) : (
        <>
          <UserRound className="shrink-0" />
          <span>Human Made</span>
        </>
      )}
    </span>
  );
};
